import { Padding } from '@mui/icons-material';
import Breadcrumb from '../Breadcrumb/Breadcrumb';
import { BannerWrapper } from './BannerStyled';


const Banner = ({Heading, Paragraph, showBreadcrumb,breadcrumbName }) => {
    return (
        <BannerWrapper>
            {/* <Breadcrumb/> */}
            {showBreadcrumb && <Breadcrumb breadcrumbName={breadcrumbName}/>}
            <div className='bannerContent' style={{paddingTop:showBreadcrumb?'0px':'20px'}}>
                <div className='bannerText'>
                    <h3>{Heading}</h3>
                    <p>{Paragraph}</p>
                </div>
            </div>

        </BannerWrapper>
    )
}

export default Banner;